import { render } from "./AccountIndex.vue?vue&type=template&id=0b03ca3c&ts=true"
import script from "./AccountIndex.vue?vue&type=script&lang=ts"
export * from "./AccountIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__